// extracted by mini-css-extract-plugin
module.exports = {"Comment":"clientComments_Comment__LD67a","CommentBaltex":"clientComments_CommentBaltex__3NQ6b"};